import { render, staticRenderFns } from "./column-title.vue?vue&type=template&id=c94eb820&lang=pug"
import script from "./column-title.vue?vue&type=script&lang=js"
export * from "./column-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports